<template>
  <section class="[ max-w-7xl m-auto min-h-full flex flex-col gap-6 ]">
    <!-- Mockup banner -->
    <div
      class="[ flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded bg-amber-50 text-amber-700 border border-amber-200 w-fit ]"
    >
      <span>Mockup</span>
      <span class="[ text-amber-400 ]">&bull;</span>
      <span>Using local mock data</span>
    </div>

    <!-- Page header -->
    <div class="[ flex items-center justify-between ]">
      <h2 class="[ text-xl font-semibold ]">Page Title</h2>
      <Button label="Action" @click="showDialog = true">
        <template #icon>
          <JBIcon name="plus" />
        </template>
      </Button>
    </div>

    <!-- Loading state -->
    <div
      v-if="loading"
      class="[ flex-1 flex flex-col items-center justify-center ]"
    >
      <JBLoadingSpinner message="Loading data" />
    </div>

    <!-- Data table -->
    <DataTable v-else :value="data ?? []" striped-rows>
      <!-- <Column field="name" header="Name" sortable /> -->
      <!-- <Column field="status" header="Status" /> -->
    </DataTable>

    <!-- Create/Edit dialog -->
    <Dialog
      v-model:visible="showDialog"
      modal
      header="Create Item"
      class="[ w-full max-w-lg ]"
    >
      <!-- Form fields using @primevue/forms + yupResolver -->
      <template #footer>
        <Button
          label="Cancel"
          severity="secondary"
          outlined
          @click="showDialog = false"
        />
        <Button label="Save" @click="onSave" />
      </template>
    </Dialog>
  </section>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Button, DataTable, Dialog } from "primevue";
import { useMockApi } from "@/mocks/composables/useMockApi";
import JBLoadingSpinner from "@/components/ui/JBLoadingSpinner.vue";

definePage({
  meta: {
    title: "Mockup: Template",
  },
});

// Replace with your mock data
const { data, loading } = useMockApi([] as Record<string, unknown>[]);

const showDialog = ref(false);

function onSave() {
  // Add save logic with useMockCrud if needed
  showDialog.value = false;
}
</script>
